import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { User } from '../models/user';
import { SnotifyService } from 'ng-snotify';

@Injectable()
export class AuthService {
  currentUser: BehaviorSubject<User> = new BehaviorSubject<User>(null);

  constructor(private cookieService: CookieService, private router: Router, private http: HttpClient, private snotifyService : SnotifyService) { }

  public userLoggedIn() {
    let cookieExists = this.cookieService.check('User');
    if (!cookieExists) {
      return false;
    }

    return true;
  }

  public setUser(user) {
    this.cookieService.set('User', JSON.stringify(user), 1);
    this.currentUser.next(user);
  }

  public getUser(): BehaviorSubject<User> {
    if (this.currentUser.value != null) {
      this.currentUser.next(this.currentUser.value);
    }

    console.log("Cookie");
    let cookieExists = this.cookieService.check('User');
    if (!cookieExists) {
      return null;
    }

    let cookieUser = this.cookieService.get('User');
    this.currentUser.next(<User>JSON.parse(cookieUser));
  }

  public logout() {
    console.log("Logout");
    this.currentUser.next(null);
    this.cookieService.delete('User');

    this.router.navigate(['/login']);
  }

  reset(username: string): Promise<any> {
    const headers = {
      'Content-Type': 'application/json',
    };

    var dto = {
      username: username,
    };


    return new Promise((resolve, reject) => {
      this.http.post<any>(environment.apiUrl + "auth/reset", dto, { headers: headers }).subscribe(data => {
        resolve(data);
        if (data) {
          this.snotifyService.success('Password reset email has been sent.');
        } else {
          this.snotifyService.error('Failed to send password reset. Please check the username and try again.');
        }
      }, (error) => {
        this.snotifyService.error('An error occurred. Please try again later.');
        resolve(null);
      });
    });
  }

  resetPassword(token: string, password: string): Promise<any> {
    const headers = {
      'Content-Type': 'application/json',
    };
  
    const dto = {
      token: token,
      password: password,
    };
  
    return new Promise((resolve, reject) => {
      this.http.post<any>(environment.apiUrl + "auth/ResetPassword", dto, { headers: headers }).subscribe(
        (data) => {
          if (data && data.success) {
            this.snotifyService.success(data.message || 'Password has been reset successfully.');
            resolve(data);
          }
        },
        (error) => {
          if (error.status === 400 && error.error && error.error.message) {
            const errorCode = error.error.message.replace("Password validation failed: ", "").trim();
  
            switch (errorCode) {
              case "Password_empty":
                this.snotifyService.error(`Password can't be empty`, { timeout: 4000 });
                break;
              case "Password_not_long":
                this.snotifyService.error(`Password should be a minimum of 12 characters long`, { timeout: 4000 });
                break;
              case "Password_no_digits":
                this.snotifyService.error(`Password must at least contain one digit`, { timeout: 4000 });
                break;
              case "Password_no_chars":
                this.snotifyService.error(`Password must include special characters`, { timeout: 4000 });
                break;
              default:
                this.snotifyService.error(error.error.message || 'Failed to reset password. Please try again.', { timeout: 4000 });
                break;
            }
          } else {
            this.snotifyService.error('An error occurred. Please try again later.');
          }
  
          resolve(null);
        }
      );
    });
  }
  

  login(username: string, password: string, rememberMe: boolean): Promise<any> {
    const headers = {
      'Content-Type': 'application/json',
    };

    var dto = {
      username: username,
      password: password
    };
    console.log(dto);
    return new Promise((resolve, reject) => {
      this.http.post<any>(environment.apiUrl + "auth/login", dto, { headers: headers }).subscribe(data => {
        this.setUser(data);
        //localStorage.setItem("login", JSON.stringify(dto))
        localStorage.setItem("currentUser", JSON.stringify(data));
        console.log(data);
        if (rememberMe)
          localStorage.setItem("@user", JSON.stringify(dto));

        this.currentUser.next(data);

        resolve(data);
      }, (error) => {
        resolve(null)
      });
    });
  }

  public getWelders(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>('/api/account/getwelders').subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

}
